var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaidBill1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62 5.1v42.52l-14.38 14.38h-27a3.1 3.1 0 0 1 -3.1-3.1v-53.8a3.1 3.1 0 0 1 3.1-3.1h38.28a3.1 3.1 0 0 1 3.1 3.1z",
    fill: "#dfe6e9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m62 47.62-14.38 14.38v-11.28a3.1 3.1 0 0 1 3.1-3.1z",
    fill: "#778ca3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#365e7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.38 11.74h-17.24a1 1 0 0 1 0-2.07h17.24a1 1 0 1 1 0 2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.38 20.22h-17.24a1 1 0 0 1 0-2.06h17.24a1 1 0 1 1 0 2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.38 28.71h-17.24a1 1 0 0 1 0-2.07h17.24a1 1 0 1 1 0 2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.38 37.19h-29.25a1 1 0 1 1 0-2.06h29.25a1 1 0 1 1 0 2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.76 45.68h-7.76a1 1 0 0 1 0-2.07h7.76a1 1 0 0 1 0 2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.66 27.19h-7.53a1 1 0 0 1 0-2.07h6.5v-4.12h-6.5a1 1 0 0 1 -1-1v-6.26a1 1 0 0 1 1-1h7.53a1 1 0 0 1 0 2.07h-6.49v4.13h6.49a1 1 0 0 1 1 1v6.21a1 1 0 0 1 -1 1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9 30.23a1 1 0 0 1 -1-1v-18.52a1 1 0 1 1 2.07 0v18.48a1 1 0 0 1 -1.07 1.04z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.45 48.23-13.77 13.77-9.68-9.68 4-4 5.68 5.68 9.77-9.77z",
    fill: "#26de81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidBill1);
export default __webpack_public_path__ + "static/media/paid-bill (1).2c346d51109ec549637f4827360458bc.svg";
export { ForwardRef as ReactComponent };